import { Box, Button } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import { ExpandLess } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const Footer = ({
  enableDarkTheme,
  setItemOpen,
  isAcknowledged,
  acknowledgeNotification,
}: {
  enableDarkTheme: boolean;
  setItemOpen: (arg: boolean) => void;
  isAcknowledged: boolean;
  acknowledgeNotification: () => void;
}) => {
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const { t } = useTranslation();
  const fontColor = palette.textPrimary;

  return (
    <Box
      sx={{
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {isAcknowledged ? (
        <Button
          sx={{
            color: fontColor,
            padding: '6px 20px 6px 20px',
            textTransform: 'none',
            fontSize: '12px',
            border: '1px solid #3666EC',
          }}
          disabled
        >
          {t('marked_as_reviewed')}
        </Button>
      ) : (
        <Button
          sx={{
            color: fontColor,
            padding: '6px 20px 6px 20px',
            textTransform: 'none',
            fontSize: '12px',
            border: '1px solid #3666EC',
          }}
          onClick={() => {
            acknowledgeNotification();
          }}
        >
          {t('mark_as_reviewed')}
        </Button>
      )}

      <Button
        sx={{
          color: fontColor,
          padding: '6px 20px 6px 20px',
          textTransform: 'none',
          fontSize: '12px',
        }}
        onClick={() => {
          setItemOpen(false);
        }}
      >
        {t('collapse_details')} <ExpandLess />
      </Button>
    </Box>
  );
};
